var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{class:_vm.iconClass,attrs:{"width":_vm.width,"height":_vm.height,"viewBox":_vm.viewBox,"xmlns":_vm.xmlns},domProps:{"innerHTML":_vm._s(_setup.iconData)}})
}
var staticRenderFns = []

export { render, staticRenderFns }